import { render } from "./RecipeForm.vue?vue&type=template&id=33c4c376"
import script from "./RecipeForm.vue?vue&type=script&lang=js"
export * from "./RecipeForm.vue?vue&type=script&lang=js"

import "./RecipeForm.vue?vue&type=style&index=0&id=33c4c376&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__